import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {v4} from 'node-uuid';
import FormField from './FormField';

import styles from './FormCheckbox.scss'

export default class FormCheckbox extends PureComponent {
    static propTypes = {
        className: PropTypes.string,
        label: PropTypes.string,
        checkboxLabel: PropTypes.string,
        fieldKey: PropTypes.string.isRequired,
        checked: PropTypes.bool,
        value: PropTypes.bool,
        plainChangeHandler: PropTypes.bool,
        error: PropTypes.string,
        labelNote: PropTypes.string,
        onChange: PropTypes.func,
    };

    static defaultProps = {
        checked: false,
        value: false,
        className: null,
        label: '',
        checkboxLabel: '',
        error: null,
        plainChangeHandler: false,
    };

    checkboxUid = v4();

    render() {
        const {
            label,
            error,
            fieldKey,
            checked,
            value,
            className,
            labelNote,
            checkboxLabel
        } = this.props;

        const labelClassName = classNames(styles.label, error ? styles.error : '');

        const isChecked = (checked || value);

        return (
            <FormField label={label}
                className={className}
                error={error}
                labelNote={labelNote}
                >
                <div className={styles.checkboxContainer}>
                    <div className={classNames(styles.checkbox, {[styles.checked]: isChecked})} />
                    <input
                        type='checkbox'
                        className={styles.input}
                        id={`${this.checkboxUid}_${fieldKey}_input`}
                        checked={isChecked}
                        onChange={this.handleChange}
                    />
                    <label
                        className={labelClassName}
                        htmlFor={`${this.checkboxUid}_${fieldKey}_input`}
                    >
                        {checkboxLabel}
                    </label>
                </div>
            </FormField>
        )
    }

    handleChange = e => {
        const {onChange, fieldKey, plainChangeHandler} = this.props;
        if (plainChangeHandler) {
            onChange({target: {value: e.target.checked}});

            return;
        }

        onChange(fieldKey, {target: {value: e.target.checked}});
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/form/FormCheckbox.js